// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import { jsonCKBTxMember } from "./types/nervosTransaction";
import { TransactionWithScriptGroups } from "./types/nervosTransactionTypes";
import { ETHPoolCall } from "./types/liquidity";

// LPWithdrawInitResponse mirrors LPDepositInitResponse: CKB returns
// unsignedTx + expectedOutpoint; ETH returns eth call metadata with
// method "withdraw" and shares set.
@jsonObject()
export default class LPWithdrawInitResponse extends PerunMessage {
  @jsonCKBTxMember() unsignedTx?: TransactionWithScriptGroups;
  @jsonMember(String, { isRequired: false }) expectedOutpoint?: string;
  @jsonMember(ETHPoolCall, { isRequired: false }) eth?: ETHPoolCall;

  constructor(
    unsignedTx?: TransactionWithScriptGroups,
    expectedOutpoint?: string,
    eth?: ETHPoolCall,
  ) {
    super();
    this.unsignedTx = unsignedTx;
    this.expectedOutpoint = expectedOutpoint;
    this.eth = eth;
  }

  messageType(): MessageType {
    return LPWithdrawInitResponse;
  }

  messageTypeName(): MessageTypeName {
    return "LPWithdrawInitResponse";
  }
}
